export const ARE_YOU_A_MEMBER = 'are_you_a_member'
export const MEMBER_SESSION_SHOWN = 'MEMBER_SESSION_SHOWN'

export const ROOM_BOOKING_TYPE = {
  open: 'Open',
  vetted: 'Vetted',
  closed: 'Closed'
}

export const templateId = {
  bedrooms: 'f19e20bb-db80-4661-923b-49cca5741eae'
}

export const NOTES_ITEM_NAME = 'notes'
